export interface FeatureFlags {
  // Sample feature flag keeps compiler warnings at bay when no other feature flags are active.
  sampleFeatureFlag: boolean;
  enableProductSalesStatus: boolean;
  enableResourceManagement: boolean;
  enableETicket: boolean;
  enableStampRally: boolean;
  enableBookInDigitalGuidance: boolean;
  enableQRCheckinEnhancements: boolean;
  enableCustomerLedger: boolean;
  enableETicketOptionQRCode: boolean;
  enableETicketFraudDetection: boolean;
  enableCustomTopPage: boolean;
  enableSeatManagement: boolean;
  enableNewTutorial: boolean;
  enablePerBookingParticipants: boolean;
  enableSplitCheckin: boolean;
  enable3DS: boolean;
  enableBookingStartDateTime: boolean;
  enableCrossSellUpSell: boolean;
  enableCarrierEmailWarningAndEmailAutocomplete: boolean;
  enableFootprintedModal: boolean;
  enableCheckinStartTimeRelative: boolean;
  enableSMSTermsOfService: boolean;
  enablePushNotifications: boolean;
  enableETicketUXImprovements: boolean;
}

// In "development" mode, all features including those currently under development are enabled.
export const developmentFeatureFlags: FeatureFlags = {
  sampleFeatureFlag: true,
  enableProductSalesStatus: true,
  enableResourceManagement: true,
  enableETicket: true,
  enableStampRally: true,
  enableBookInDigitalGuidance: true,
  enableQRCheckinEnhancements: true,
  enableCustomerLedger: true,
  enableETicketOptionQRCode: true,
  enableETicketFraudDetection: true,
  enableCustomTopPage: true,
  enableSeatManagement: true,
  enableNewTutorial: true,
  enablePerBookingParticipants: true,
  enableSplitCheckin: true,
  enable3DS: true,
  enableBookingStartDateTime: true,
  enableCrossSellUpSell: true,
  enableCarrierEmailWarningAndEmailAutocomplete: true,
  enableFootprintedModal: true,
  enableCheckinStartTimeRelative: true,
  enableSMSTermsOfService: true,
  enablePushNotifications: true,
  enableETicketUXImprovements: true,
};

// In "release" mode, only features ready for production release are enabled.
export const releaseFeatureFlags: FeatureFlags = {
  sampleFeatureFlag: false,
  enableProductSalesStatus: true,
  enableResourceManagement: true,
  enableETicket: true,
  enableStampRally: true,
  enableQRCheckinEnhancements: true,
  enableCustomerLedger: false, // disabled for release at keihan branch
  enableBookInDigitalGuidance: true,
  enableETicketOptionQRCode: false,
  enableETicketFraudDetection: false,
  enableCustomTopPage: false,
  enableSeatManagement: false,
  enableNewTutorial: true,
  enablePerBookingParticipants: true,
  enableSplitCheckin: true,
  enable3DS: true,
  enableBookingStartDateTime: true,
  enableCrossSellUpSell: false,
  enableFootprintedModal: true,
  enableCarrierEmailWarningAndEmailAutocomplete: true,
  enableCheckinStartTimeRelative: true,
  enableSMSTermsOfService: true,
  enablePushNotifications: false,
  enableETicketUXImprovements: true,
};

// stg feature flags are not ready for release but are enabled for demo purposes in the stg environment.
// This breaks our "production is the same as staging" testing so it should be used sparingly.
export const stgDemoFeatureFlags: Partial<FeatureFlags> = {
  enableResourceManagement: true,
  enableStampRally: true,
  enableBookInDigitalGuidance: true,
  enableQRCheckinEnhancements: true,
  enableETicketOptionQRCode: true,
  enableCustomTopPage: true,
  enableNewTutorial: true,
  enableSeatManagement: true,
  enableSplitCheckin: true,
  enable3DS: true,
  enableBookingStartDateTime: true,
  enableCrossSellUpSell: true,
  enableFootprintedModal: true,
  enableCheckinStartTimeRelative: true,
  enableETicketUXImprovements: true,
};
